import { render, staticRenderFns } from "./LiteratureDialog.vue?vue&type=template&id=0d13ebb1&"
import script from "./LiteratureDialog.vue?vue&type=script&lang=ts&"
export * from "./LiteratureDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports